let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kneKj")).then(() => parcelRequire('2fDdV'));